import { IndexComponentConfigInterface } from '@/types';
import { PageList } from '@prometheus/features';
import { ModalContext, UseModalContext } from '@prometheus/hooks';
import { FC, useContext, useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import { useNavigate } from 'react-router-dom';

import { databasesConfig } from '../Databases.config';
import { getUUID } from '@prometheus/utils';
import { setBreadcrumbs } from '@prometheus/redux';
import { CreateDatabaseForm } from '../../CreateDatabaseForm';
import { useTranslation } from 'react-i18next';

export const DatabasesList: FC<{
  root: any;
  onPublish: (id: string) => void;
  isReload: string;
  setIsReload: (uuid: string) => void;
}> = ({ root, onPublish, isReload, setIsReload }) => {
  const { createEntityModal, getCols } = databasesConfig;

  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { t } = useTranslation();

  const { openModal, closeModal } = useContext<UseModalContext>(ModalContext);
  const createApi = createEntityModal.createMethodApi();
  const onCreateCdmDataSource = () => {
    openModal(
      () => (
        <CreateDatabaseForm
          createMethod={createApi?.create}
          onCancel={closeModal}
          afterCreate={values => {
            closeModal();
            setIsReload(getUUID());
          }}
        />
      ),
      t('modals.create_database_header'),
      {
        closeOnClickOutside: true,
        onClose: closeModal,
      }
    );
  };

  const onUpdateCdmDataSource = row => navigate(row.original.id);

  useEffect(() => {
    root &&
      dispatch(
        setBreadcrumbs([
          {
            name: t('breadcrumbs.admin'),
            path: `${root.rootPath}`,
          },
          {
            name: t('breadcrumbs.databases'),
            path: `${root.rootPath}/databases`,
          },
        ])
      );
  }, [root]);

  return (
    <PageList<any, any, IndexComponentConfigInterface>
      reloadId={isReload}
      isImport={false}
      isCreate={true}
      onCreate={onCreateCdmDataSource}
      moduleConfig={
        {
          rootSettings: {
            rootPath: '/admin',
            rootTitle: '',
          },
        } as any
      }
      listConfig={{
        ...databasesConfig,
        loadingMessage: t('modules.administration.databases.loading_databases'),
        addButtonTitle: t('modules.administration.databases.create_database'),
        moduleDescription: '',
        tableTitle: t('modules.administration.databases.header'),
        importButtonTitle: t('buttons.import'),
        cols: getCols({
          onPublish: onPublish,
          t,
        }),
      }}
      onRowClick={onUpdateCdmDataSource}
      variant="secondary"
      uniqName="databases"
      allowDelete={true}
      hiddenColumns={{
        'created.timestamp': false,
        'modified.timestamp': false,
        'created.user.name': false,
      }}
    />
  );
};
